<template>
  <div class="w-full flex flex-col gap-4">
    <h4 class="text-h4 font-bold">Welcome to CareerWise Connections!</h4>
    <p>
      We are so pleased that you're keen to help NZ's high school students
      unlock the full potential of their school network and the network within
      career pathway providers. Whether you can spare a few hours a week, a
      month, or a year, Kiwi high school students and their dedicated career
      advisors are grateful for your contribution.
    </p>
    <p>
      To ensure that everyone has a positive and respectful experience, we ask
      that you please review and acknowledge that you will follow and adhere to
      the following
      <span class="font-bold italic"
        >CareerWise Connections Code of Conduct.</span
      >
    </p>
    <p class="font-bold text-lg mb-0 mt-4">Working with a school</p>
    <ol>
      <li v-for="(item, index) in schoolItems" :key="index" :class="item.class">
        <p>
          <span class="font-bold mr-1">{{ index + 1 }}. {{ item.title }}:</span>
          {{ item.description }}
        </p>
      </li>
    </ol>
    <p class="font-bold text-lg mb-0 mt-4">When engaging with students</p>
    <ol>
      <li
        v-for="(item, index) in studentItems"
        :key="index"
        :class="item.class"
      >
        <p>
          <span class="font-bold mr-1">{{ item.title }}:</span>
          {{ item.description }}
        </p>
      </li>
    </ol>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalCodeOfConduct',

  setup() {
    const schoolItems = [
      {
        title: 'Be responsive',
        description:
          'To help us coordinate and plan we ask that you are responsive to any Career Advisor or student. This means acknowledging their messages in a timely manner and that any scheduled interactions are kept to or updated in a timely and professional manner.',
        class: 'mb-4',
      },
      {
        title: 'Keep us informed',
        description:
          'We will periodically check in with you to confirm your contact information and availability but if your circumstances change, please do let us know. Additionally, if you wish to withdraw from the service please let us know and we can take care of that for you.',
        class: 'mb-4',
      },
      {
        title: 'Police check',
        description:
          'Please be aware that any school you interact with may request or complete a Police Check as part of the engagement process. This is a requirement that may need completion depending on the level of engagement with individual students.',
        class: '',
      },
    ]

    const studentItems = [
      {
        title: 'Be inclusive',
        description:
          "Encourage participation from all students, regardless of their background, interests, or abilities. Listen to different perspectives and be open to their views. Keep conversations respectful and considerate of others' feelings.",
        class: 'mb-4',
      },
      {
        title: 'Keep it positive',
        description:
          'Offer encouragement and constructive feedback to support students on their career journey.',
        class: 'mb-4',
      },
      {
        title: 'Privacy',
        description:
          'Protect your privacy and the privacy of others. Avoid sharing personal information and keep what you do, what is shared and delivered confidential.',
        class: 'mb-4',
      },
      {
        title: 'Stay on topic',
        description:
          'Keep discussions relevant to the purpose of the Connections service and the engagement you are supporting. We all want this to be a positive experience, and we are grateful for your support. We do need to put the interests of students first and hence we reserve the right to remove your access to the Connections service in the event of any complaint or concern communicated to us.',
        class: '',
      },
    ]

    return {
      schoolItems,
      studentItems,
    }
  },
})
</script>
